export class PriceOptions {
    Format:string;
    Decimals:number;
    ThousandSeparator:string;
    DecimalSeparator:string;
    Symbol:string;
}

export class CurrencyManager {
    public static WasInitialized:boolean=false;
    constructor(public Options:PriceOptions)
    {

    }
    public static Initialize(option)
    {
        CurrencyManager.WasInitialized=true;
        (window as any).RNPriceManager=new CurrencyManager(option);
    }

    private static GetInstance() :CurrencyManager{
        return (window as any).RNPriceManager;
    }

    public static FormatPrice(amount:any){
        return CurrencyManager.GetInstance().InternalFormatPrice(amount);
    }

    private InternalFormatPrice(amount:any)
    {
        amount=parseFloat(amount);
        if(isNaN(amount))
            amount=0;

        let text=amount.toFixed(this.Options.Decimals);
        var x = text.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        if(this.Options.ThousandSeparator!='') {
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + this.Options.ThousandSeparator + '$2');
            }
        }

        if(x2.length>0)
        {
            x2=x2.slice(1);
            x2=this.Options.DecimalSeparator+x2;
        }
        text= x1 + x2;

        let price=this.Options.Format.replace('%2$s',text);
        price=price.replace('%1$s',this.Options.Symbol);

        return price;

    }



}